import {
  AccountDocumentBasicResponse,
  AccountDocumentDetailResponse,
  AccountDocumentStatusEnum,
} from '@monetize/types/app';
import { useNavigate } from 'react-router';
import DataTableActions from '../../../components/Monetize/DataTable/MDataTableActions';
import { useACL } from '../../../services/acl/acl';

import { useDeleteAccountDocument } from '../../../api/accountsService';
interface AccountDocumentActionsProps {
  accountId: string;
  accountDocument: AccountDocumentBasicResponse | AccountDocumentDetailResponse;
  refetch?: () => void;
}

export const AccountDocumentActions = ({
  accountId,
  accountDocument,
  refetch,
}: AccountDocumentActionsProps) => {
  const { canDo } = useACL();
  const navigate = useNavigate();

  const { mutateAsync: deleteAccountDocument } = useDeleteAccountDocument();

  const actions = [
    {
      title: 'Delete',
      enabled: accountDocument.status === AccountDocumentStatusEnum.CREATED,
      color: 'danger',
      action: () =>
        deleteAccountDocument({
          accountId,
          accountDocumentId: accountDocument.id,
        }),
    },
  ];

  if (!accountId || !accountDocument) {
    return null;
  }

  return <DataTableActions actions={actions} />;
};
